import Ad from "./Ad";

export default Ad;
